import { useErrorHandler } from "react-error-boundary"

import { useGetValuation } from "./endpoints/valuation/hook"
import { AppState, Actions } from "../state/store"
import { useGetBooking } from "./endpoints/booking/hook"
import { useAuthToken } from "./endpoints/token/token"
import { useGetVehicleDetailsWithImage } from "./endpoints/vehicleDetailsWithImage/hook"
import { useGetLead } from "./endpoints/lead/hook"
import { useGetValuationLimit } from "./endpoints/getValuationLimit/hook"
import { useGetValuationWithoutLead } from "./endpoints/valuationWithoutLead/hook"
import { useGetStockStatus } from "./endpoints/getStockStatus/hook"
import { useStockAuthToken } from "./endpoints/stockToken/stockToken"

export interface LocationParams {
  pathname: string
  state: {}
  search: string
  hash: string
  key: string
}

export const useApi = (state: AppState, actions: Actions) => {
  const handleError = useErrorHandler()

  const {
    addVehicleDetails,
    addAuth,
    addValuation,
    addBookingStatus,
    addLead,
    addValuationLimit,
    addStockAuth,
    addExistsInStock
  } = actions

  useAuthToken(addAuth, handleError)
  useStockAuthToken(addStockAuth, handleError);
  const getVehicleDetails = useGetVehicleDetailsWithImage(addVehicleDetails)
  const getBooking = useGetBooking(addBookingStatus)
  const getValuation = useGetValuation(addValuation, handleError)
  const getValuationWithoutLead = useGetValuationWithoutLead(
    addValuation,
    handleError
  )
  const getLead = useGetLead(addLead)
  const getValuationLimit = useGetValuationLimit(
    addValuationLimit,
    addValuation,
    handleError
  )
  const getStockStatus = useGetStockStatus(addExistsInStock, handleError)

  return {
    getVehicleDetails: (history: any) => getVehicleDetails(state, history),
    getValuation: (history: any) => getValuation(state, history),
    getBooking: () => getBooking(state),
    getLead: (history: any) => getLead(state, history),
    getValuationLimit: (history: any) => getValuationLimit(state, history),
    getValuationWithoutLead: (history: any) => getValuationWithoutLead(state, history),
		getStockStatus: () => getStockStatus(state),
  }
}
